import { reactionSchema } from '@/models/reaction';
import { apiPath } from '@/redux/apiPath';
import { axiosInstance } from '@/services/api/utils/axiosInstance';
import { Reaction } from '@/types/models';
import { ThunkConfig } from '@/types/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { z } from 'zod';
import { getError } from '@/utils/error-report/getError';
import { REACTIONS_FETCHING_ERROR_PREFIX } from './reactions.constants';

type GetReactionsByIdsArgs =
  | number[]
  | {
      ids: number[];
      shouldConcat?: boolean;
    };

export type GetReactionsByIdsResult = {
  data: Reaction[];
  shouldConcat: boolean;
};

export const getReactionsByIds = createAsyncThunk<
  GetReactionsByIdsResult | undefined,
  GetReactionsByIdsArgs,
  ThunkConfig
>('reactions/getByIds', async args => {
  const ids = args instanceof Array ? args : args.ids;
  const shouldConcat = args instanceof Array ? false : args.shouldConcat || false;

  try {
    const response = await axiosInstance.get<Reaction[]>(apiPath.getReactionsWithIds(ids));

    const isDataValid = validateDataUsingZodSchema(response.data, z.array(reactionSchema));

    if (!isDataValid) {
      return undefined;
    }

    return {
      data: response.data,
      shouldConcat,
    };
  } catch (error) {
    return Promise.reject(getError({ error, prefix: REACTIONS_FETCHING_ERROR_PREFIX }));
  }
});
